import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import Button from "common-components/Buttons";
import Modal from "common-components/Modal/Modal";

const PendingAuthorizedAgentModal = ({ modalContent, handleClick, ...props }) => (
  <Modal
    style={{ maxWidth: "546px", maxHeight: "365px" }}
    closeModal={handleClick}
    contentLabel="pending agent request modal"
    {...props}
  >
    <h2 style={{ maxWidth: "396px", marginBottom: "15px" }}>{modalContent.section_title}</h2>

    <Div style={{ maxWidth: "415px", marginBottom: "40px" }}>
      {convertStringToElements(modalContent.section_description)}
    </Div>

    <Button background={modalContent.buttons[0].type} onClick={handleClick}>
      {modalContent.buttons[0].text}
    </Button>
  </Modal>
);

export default PendingAuthorizedAgentModal;

PendingAuthorizedAgentModal.propTypes = {
  modalContent: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired
};

const Div = styled.div`
  p {
    padding: 10px 0;
  }
`;
